import React from 'react';
import PropTypes from 'prop-types';
import { connect } from '@gasbuddy/react';
import Card from '../../card';
import Notification from '../../notification';
import BrandViewContent from './brand-view-content';
import BrandEditModal from './brand-edit-modal';
import StationPropType from '../../../utils/prop-types/station';
import { editStation } from '../../../actions';
import AllBrandsTypeProps from '../../../utils/prop-types/all-brands';

const { api } = require('../../../../lib/bputils').default;
const { canEditStationInfo } = require('../../../../lib/permissions').default;

class StationBrandsCard extends React.Component {
  static propTypes = {
    dispatchEditStation: PropTypes.func,
    isLoading: PropTypes.bool,
    station: StationPropType,
    allBrands: AllBrandsTypeProps.isRequired,
  }

  static defaultProps = {
    dispatchEditStation: null,
    isLoading: false,
    station: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      brandings: props.station.brandings,
      displayName: props.station.display_name,
      isLoading: props.isLoading,
    };
  }

  componentDidUpdate = (prevProps) => {
    const { station: { brandings, display_name: displayName }, isLoading } = this.props;
    if (prevProps.isLoading !== isLoading
      || prevProps.station.display_name !== displayName
      || !_.isEqual(prevProps.station.brandings, brandings)) {
      this.setState(() => ({ displayName, brandings, isLoading }));
    }
  }

  handleOnSave = ({ brandings, displayName }) => {
    const { station, dispatchEditStation } = this.props;
    const { fuel_brand_id: fuelBrandId, cstore_brand_id: cstoreBrandId } = brandings;
    this.setState(() => ({
      isLoading: true,
    }));
    const stationInfo = {
      brand_id: fuelBrandId > 0 ? fuelBrandId : cstoreBrandId,
      brandings: {
        fuel_brand_id: fuelBrandId,
        cstore_brand_id: cstoreBrandId,
      },
      display_name: displayName,
    };
    api.put({
      path: `/stations/${station.id}/information`,
      data: stationInfo,
    })
      .then(() => {
        dispatchEditStation({ brandings, display_name: displayName });
        Notification.success('Station brands were successfully updated');
        this.setState(() => ({ isLoading: false }));
      })
      .catch(() => Notification.error('There was an error updating station brands. Please contact support.'));
  }

  render = () => {
    const { isLoading, brandings, displayName } = this.state;
    const { allBrands } = this.props;

    if (!allBrands) {
      return (<></>);
    }

    return (
      <Card
        title="STATION BRANDS"
        showCollapseButton
        showEditButton={canEditStationInfo()}
        minHeight={270}
        isLoading={isLoading}
        editModal={(
          <BrandEditModal
            brandings={brandings}
            displayName={displayName}
            allBrands={allBrands}
            onSave={this.handleOnSave}
          />
        )}
      >
        <BrandViewContent />
      </Card>
    );
  }
}

const mapStateToProps = state => ({
  station: state.station,
  isLoading: state.loading,
  allBrands: state.brands,
});

const mapDispatchToProps = dispatch => ({
  dispatchEditStation: stationEdit => dispatch(editStation(stationEdit)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StationBrandsCard);
